import PAGE from "modules/router/page";
import { XUANAPI } from "modules/uri";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { MainView } from "../../modules/mainview";
import { FirstContent } from "./first-content";
import { SecondContent } from "./second-content";
import Modal from "../../modules/UserModal";
import { commonErrorMessage } from "modules/constant";

export function HomePage(props: RouteComponentProps) {
  const [error, setError] = React.useState<string>("");
  const policyNumber = (props.match?.params as any).policynumber || null;

  const verifyIdCardBO = async (secuityNo: string, policyNumber: string) => {
    try {
      const data = {
        policyNumber: policyNumber,
        secuityNo: secuityNo,
      };

      const resp = await fetch(`${XUANAPI}/verified`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const respData = await resp.json();
      return respData;
    } catch (err) {
      return null;
    }
  };

  const goToInvoicesList = async (secuityNo: string) => {
    if (secuityNo) {
      const verify = await verifyIdCardBO(secuityNo, policyNumber);
      if (verify) {
        if (verify.status === "SUCCESS") {
          localStorage.setItem("token", verify.token);
          props.history.push(`${PAGE.INVOICESlIST}/${policyNumber}`);
          return;
        }
        if (verify.oErrorResult) {
          setError(verify.oErrorResult?.errorDescription || commonErrorMessage);
          return;
        }
      }
    }
    setError(commonErrorMessage);
  };

  const handleCloseModal = () => {
    setError("");
  };

  React.useEffect(() => {
    localStorage.removeItem("token");
  }, []);

  return (
    <MainView>
      <FirstContent onSubmit={(secuityNo) => goToInvoicesList(secuityNo)} />
      <SecondContent />
      <Modal
        title="Thông báo"
        content={error}
        titleSubmit="Thoát"
        open={error ? true : false}
        handleSubmit={handleCloseModal}
      />
    </MainView>
  );
}
